import { nanoquery, type MutatorStore } from '@nanostores/query'
import { manifest } from './manifest-store'
import { type SessionResponse } from '../../models/SessionData'
import { agentStore } from './stores'
import { mergeCart } from './cart-store'
import { updateAccountInfo } from './account-info-store'
import { SessionStatusType, type User } from '../../models/User'

enum SigninEventStatus {
  ANONYMOUS = 'ANONYMOUS',
  SIGNED_IN = 'SIGNED_IN',
}

export const [createUserFetcherStore, createUserMutatorStore] = nanoquery({
  fetcher: async (..._keys: (string | number | boolean)[]): Promise<User | undefined> => {
    const $manifest = manifest.get()
    const { getUserClient, createSessionClient } = await import(/* @vite-ignore */ $manifest.mfe_account.client.url)

    const $agentStore = agentStore.get()
    const $agent = $agentStore.data

    const agentData = sessionStorage.getItem('agentData')
    const agentDataObj = agentData ? JSON.parse(agentData) : undefined

    if (agentDataObj && agentDataObj.agentMode && !$agent) {
      return {
        sessionStatus: SessionStatusType.ANONYMOUS,
      }
    }

    let session: SessionResponse
    if ($agent) {
      session = { sessionStatus: SessionStatusType.LOGGEDIN }
    } else {
      // get latest session information for user. Only valid source of session status truth.
      session = await createSessionClient()
    }

    // if anonymous just return status without any user information
    if (session.sessionStatus === SessionStatusType.ANONYMOUS) {
      triggerUserSigninUpdatedEvent(SigninEventStatus.ANONYMOUS)
      return {
        sessionStatus: SessionStatusType[session.sessionStatus],
      }
    }

    // call to get user information for logged in or soft logged in users
    try {
      const userData = await getUserClient($agent)
      triggerUserSigninUpdatedEvent(SigninEventStatus.SIGNED_IN)
      return {
        ...session,
        ...userData,
        sessionStatus: SessionStatusType[session.sessionStatus],
      }
    } catch (e: any) {
      // any exception results in anonymous status no logged in
      triggerUserSigninUpdatedEvent(SigninEventStatus.ANONYMOUS)
      return {
        sessionStatus: SessionStatusType[session.sessionStatus],
      }
    }
  },
})

/**
 * used to trigger to kohls app
 * */
const triggerUserSigninUpdatedEvent = (status: SigninEventStatus) => {
  document.dispatchEvent(
    new CustomEvent('SHOPNEXT_EVENT_SOURCE', {
      detail: {
        eventName: 'USER_SIGNIN_FETCHED',
        version: '1',
        createdAt: new Date().toJSON(),
        data: {
          status: status,
        },
      },
    })
  )
}

export const mutateUser = createUserMutatorStore<MutatorStore>(async ({ revalidate }: any) => {
  await mergeCart.mutate()
  await updateAccountInfo.mutate()
  revalidate('user')
  return
})
